import React, {useEffect, useRef, useState} from "react";
import {PageHeader, Paragraph} from "BaseComponents/Text/";
import {useDispatch, useSelector} from "react-redux";
import propTypes from "prop-types";
import {searchActions} from "Framework/redux/actions/index";
import {DropdownLabel, InnerWrapper, NoHitsTextParagraph, SearchHit, SearchTop, SearchTopWrapper} from "../Search/hits";
import {Pagination} from "../Pagination"
import {HitsPaginationWrapper, SearchPaginationWrapper,} from "./hits/StyledSearchPagination";
import {Icon, Input, InputWrapper, SearchButton,} from "../SearchField/StyledSearchFieldComponents";
import {Dropdown} from "../Dropdown/Dropdown";

export const SearchPagination = ({
                                     Heading,
                                     SearchHits,
                                     TotalHits,
                                     IsMixedContent,
                                     FilterCategoryName,
                                     FilterSearchName,
                                     ShowAllText,
                                     SearchQuery: {
                                         CurrentCulture,
                                         CurrentPageId,
                                         DocumentTypes,
                                         IsFallbackText,
                                         FallbackSearchText,
                                         NoHitsText,
                                         Query,
                                         Skip,
                                         StartPageId,
                                         Take,
                                         SearchHitsText,
                                         TakeNrFromPage,
                                         Categories,
                                         CategoryTags,
                                         OrderByDate = true
                                     },
                                     AllCategories,
                                     withCategoriesTags = false
                                 }) => {
    const state = useSelector((state) => state.search);
    const [loading, setLoading] = useState(useSelector((state) => state.loading));
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState([]);
    const [take, setTake] = useState(Take);
    const [skip, setSkip] = useState(Skip < 0 ? 0 : Skip);
    const [searchHitsText, setSearchHitsText] = useState(
        useSelector((state) => state.searchHitsText)
    );
    const [initialSearch, setInitialSearch] = useState(true);
    const [initialSearchTake, setInitialSearchTake] = useState(true);
    const [initialSearchCategory, setInitialSearchCategory] = useState(true);
    const [initialSearchQuery, setInitialSearchQuery] = useState(true);
    const [initialSearchSkip, setInitialSearchSkip] = useState(true);
    const [searchQuery, setSearchQuery] = useState(
        useSelector((state) => state.query)
    );
    const [searchHits, setSearchHits] = useState([]);
    // const [filteredHits, setFilteredHits] = useState([]);
    const [hitCount, setHitCount] = useState(
        useSelector((state) => state.TotalCount)
    );
    const [isMixedContent, setIsMixedContent] = useState(
        useSelector((state) => state.isMixedContent)
    );
    const [currentPage, setCurrentPage] = useState(null);
    const dispatch = useDispatch();
    const inputEl = useRef(null);
    const onDropdownChange = (selected) => {
        setSkip(Skip);
        if (selected != null) {
            setSelectedCategory({value: selected.value, label: selected.label});
        } else {
            setSelectedCategory(undefined);
        }
        setTake(Take);
    };

    const FocusInput = (e) => {
        e.preventDefault();
        inputEl.current.focus();
    };

    useEffect(() => {
        setSearchHits(state.items);
        setHitCount(state.TotalCount);
        setLoading(state.loading);
        setSearchHitsText(state.searchHitsText);
    }, [state.items, state.loading]);

    useEffect(() => {
        let allCat = [];
        AllCategories?.map((cat, i) => {
            allCat.push({value: cat, label: cat});
        });
        setCategories(allCat);
        inputEl.current.value = Query;
        if (Query !== undefined) {
            setSearchQuery(Query);
        }
        GetMore(0);
    }, []);

    useEffect(() => {
        if (initialSearchQuery) {
            setInitialSearchQuery(false);
        } else {
            GetMore();
        }
    }, [searchQuery]);

    useEffect(() => {
        if (initialSearchCategory) {
            setInitialSearchCategory(false);
        } else {
            GetMore();
        }
    }, [selectedCategory]);

    useEffect(() => {
        if (initialSearchTake) {
            setInitialSearchTake(false);
        } else {
            GetMore();
        }
    }, [take]);

    const Get = (initial, force = false) => {
        if (force || !state.loading && (
            (searchQuery !== undefined && searchQuery.length > 0) ||
            initialSearch || selectedCategory)
        ) {
            setLoading(true);
            dispatch(
                searchActions.get(
                    initial ? SearchHits : searchHits,
                    initial ? Query : searchQuery !== undefined ? searchQuery : Query,
                    initial ? Take : take,
                    initial ? Skip : skip,
                    initial ? SearchHitsText : searchHitsText,
                    CurrentCulture,
                    DocumentTypes,
                    StartPageId,
                    CurrentPageId,
                    TakeNrFromPage,
                    initialSearch,
                    TotalHits,
                    initial ? IsMixedContent : isMixedContent,
                    OrderByDate,
                    initial ? Categories : withCategoriesTags ? null : [selectedCategory.value],
                    initial ? CategoryTags : withCategoriesTags ? [selectedCategory.value] : null,
                    true
                )
            );
        }
    };
    const GetMore = (forceSkip) => {
        if (!loading) {
            setLoading(true);
            dispatch(
                searchActions.more(
                    searchHits,
                    searchQuery !== undefined ? searchQuery : Query,
                    take,
                    forceSkip || forceSkip === 0 ? forceSkip : skip,
                    searchHitsText,
                    CurrentCulture,
                    DocumentTypes,
                    StartPageId,
                    CurrentPageId,
                    TakeNrFromPage,
                    initialSearch,
                    initialSearch ? IsMixedContent : isMixedContent,
                    OrderByDate,
                    !selectedCategory || selectedCategory?.length === 0 ? Categories : withCategoriesTags ? null : [selectedCategory.value],
                    !selectedCategory || selectedCategory?.length === 0 ? CategoryTags : withCategoriesTags ? [selectedCategory.value] : null,
                    true
                )
            );
        }
    };
    const HandleClick = () => {
        if (inputEl.current.value !== searchQuery) {
            // setSelectedCategory("");
            setSearchQuery(inputEl.current.value);
        }
    };

    const HandleEnterClick = (e) => {
        if (e.key === "Enter") {
            HandleClick();
        }
    };
    // const getSearchTextString = () => {
    //     const showNumber = currentPage * take > hitCount ? hitCount : currentPage * take;
    //     let text =
    //         searchHits?.length > 0
    //             ? `Visar <b> ${showNumber} </b>av <b>${hitCount}</b> 
	// ${state.query != "" ? `på "${state.query}"` : "träffar"}`
    //             : "";
    //     return text;
    // };


    const onPageChanged = (event) => {
        const {currentPage} = event;
        setCurrentPage(currentPage);
        const inSkip = take * (currentPage - 1);
        setSkip(inSkip < 0 ? 0 : inSkip);
        GetMore(inSkip < 0 ? 0 : inSkip);

    }

    return (
        <>
            <SearchTopWrapper>
                {Heading && <PageHeader Heading={Heading} margin="0 0 15px 0"/>}
                <SearchTop>
                    <InnerWrapper>
                        <DropdownLabel>{FilterCategoryName}</DropdownLabel>
                        <Dropdown
                            placeHolderText={ShowAllText}
                            {...{categories, selectedCategory}}
                            handleChange={(selectedCategory) =>
                                onDropdownChange(selectedCategory)
                            }
                        />
                    </InnerWrapper>
                    <InnerWrapper>
                        <DropdownLabel>{FilterSearchName}</DropdownLabel>
                        <InputWrapper onClick={(e) => FocusInput(e)}>
                            <SearchButton
                                disabled={IsFallbackText}
                                onClick={(e) => HandleClick()}
                            >
                                <Icon className="icon-search"></Icon>
                            </SearchButton>
                            <Input
                                ref={inputEl}
                                placeholder={FilterSearchName}
                                onKeyDown={(e) => HandleEnterClick(e)}
                                disabled={IsFallbackText}
                            />
                        </InputWrapper>
                    </InnerWrapper>
                </SearchTop>
                <Paragraph
                    large
                    dangerouslySetInnerHTML={{
                        __html: searchHitsText,
                    }}
                ></Paragraph>
                {IsFallbackText && (
                    <Paragraph
                        large
                        bold
                        display="block"
                        margin="1rem 0 0 0"
                        dangerouslySetInnerHTML={{__html: FallbackSearchText}}
                    ></Paragraph>
                )}
            </SearchTopWrapper>
            <HitsPaginationWrapper>             
                {(!loading && searchHits !== undefined) &&
                    searchHits.map((c, i) => {
                            return <SearchPaginationWrapper key={i}>
                                <SearchHit {...c} isMixedContent={isMixedContent}/>
                            </SearchPaginationWrapper>
                        }
                    )}
                {/* {searchHits !== undefined && searchHits.map((hit, i) => <p>{hit.Heading}</p>)} */}
                {!state.loading && hitCount == 0 && (
                    <NoHitsTextParagraph>{NoHitsText}</NoHitsTextParagraph>
                )}
            </HitsPaginationWrapper>
            {
                searchHits != undefined && (<Pagination totalRecords={hitCount}
                                                        pageLimit={take}
                                                        pageNeighbours={0}
                                                        onPageChanged={onPageChanged}></Pagination>
                )
            }
        </>
    );
};

SearchPagination.propTypes = {
    Heading: propTypes.string,
};
